/**
 * Поля ключа трека — решение Interface Consilium 02.09 и владельца.
 *
 * ШОВ ОКАЗАЛСЯ ШИРЕ, ЧЕМ НАЗЫВАЛ ЭПИК. Висяк заседания записан как расхождение ИМЁН: вердикт
 * M2 назвал рабочее `trackUrl`, лемма M4 — `temporaryKey?`. Вскрытие трёх `EXPECTATIONS.md`
 * показало расхождение ФОРМЫ: блок `contract` ждал одно необязательное поле, блок `key-ttl` —
 * два обязательных.
 *
 * Сведено на консилиуме (протокол:
 * `docs/discussions/cowork-sprint-cowork-library-open-api-interface-consilium.md`):
 *
 * 1. ИМЯ — `trackUrl`. `temporary*` становится ЛОЖЬЮ при снятом сроке, а снятый срок —
 *    законное состояние: право владельца снять его закрыто штормом. Имя, способное стать
 *    ложью, не берётся.
 * 2. ОБЯЗАТЕЛЬНОСТЬ — поле обязательное, `?` снят. Отсутствующее поле неотличимо от «ключ не
 *    выдан», «квота исчерпана» и «сериализатор забыл»; это класс `hasMore` — форма, лгущая
 *    молчанием. Отказ выдать ключ обязан быть ОТКАЗОМ, а не пропуском поля.
 * 3. ЧИСЛО ПОЛЕЙ — два. Эскалировано владельцу (S-C2), потому что вердикт M2 называл ОДНО
 *    поле, «заменяющее собой `storageRef`», и двенадцатого не назначала ни одна комната.
 *    Решение владельца 02.09: контракт наружу становится 11 + 2 — осознанное расширение
 *    вердикта, а не умолчание сборки.
 *
 * Основание за второе поле принято от `key-ttl`: читатель обязан мочь вычислить срок жизни
 * ссылки САМ, не разбирая чужую query-string, — ровно та логика, которой M2 отверг `hasMore`.
 *
 * Имена по-прежнему живут ОДНИМ источником: тип, сериализатор, схема OpenAPI и зубы выводятся
 * отсюда.
 */

/** Адрес, по которому партнёр идёт анонимно. */
export const TRACK_KEY_FIELD = 'trackUrl';

/** Срок жизни ссылки, видимый снаружи без разбора строки запроса. */
export const TRACK_KEY_EXPIRES_FIELD = 'trackUrlExpiresAt';

export const TRACK_KEY_FIELDS = [TRACK_KEY_FIELD, TRACK_KEY_EXPIRES_FIELD] as const;

export type TrackKeyField = (typeof TRACK_KEY_FIELDS)[number];

/**
 * Выдача ключа как её отдаёт генератор (`key-ttl`): адрес и срок.
 *
 * `expiresAt === null` — единственная наружная форма «срок снят человеком», и приходит она
 * только из `source === 'lifted'` с подписью. Бессрочность НАЗНАЧАЕТСЯ словом, а не возникает
 * из пустоты, порчи или прошедшей даты — это инвариант блока `key-ttl`, и форма его не
 * переизобретает, а везёт.
 */
export interface TrackKeyGrant {
  readonly url: string;
  readonly expiresAt: string | null;
}
